<template>
  <stripe-payment-card />
</template>

<script>
import StripePaymentCard from '@/components/StripePaymentCard.vue'

export default {
  components: { StripePaymentCard }
}
</script>
